import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import {
  Row, Col,
  Breadcrumb, BreadcrumbItem,
  Button, ButtonGroup,
  FormGroup, Label,
  Modal, ModalBody
} from 'reactstrap';

import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import ButtonSubmit from 'react-validation/build/button';
import Select from 'react-validation/build/select';
import RestartButton from '../../../images/restart.png';
import { Email, required, noSpace, minChar8, email } from '../../formValidation';
import $ from 'jquery';
import TwoFactorForm from './TwoFactorForm/TwoFactorForm';
import '../../../styles/common-form-styles.css';
import './Account.css';

import { translate } from 'react-i18next';
class Password extends Component {

  constructor(props) {
    super(props);
    this.state = {};

    this.changePassword = this.changePassword.bind(this);
  }

  changePassword(event) {
    event.preventDefault();
    const formVal = this.form.getValues();

    $.ajax({
      url: '/api/v1/update/password',
      type: 'PUT',
      data: JSON.stringify(formVal),
      success: function (res) {
        this.props.notifySuccess(res.message);
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }

  render() {
    return (
      <Form className="  UserForm" ref={c => { this.form = c }} onSubmit={this.changePassword}>
        <Col xs="12" lg="8">
          <FormGroup className="mb-4">
            <Label for="oldPassword" className="mr-sm-2">Senha Antiga</Label>
            <Input type="password" name="oldPassword" id="oldPassword" className="form-control" validations={[noSpace, required, minChar8]} />
          </FormGroup>
          <FormGroup className="mb-4">
            <Label for="newPassword" className="mr-sm-2">Nova senha</Label>
            <Input type="password" name="newPassword" id="newPassword" className="form-control" validations={[noSpace, required, minChar8]} />
          </FormGroup>
          <FormGroup className="mb-4">
            <Label for="confirmPassword" className="mr-sm-2">Confirme a Senha</Label>
            <Input type="password" name="confirmPassword" id="confirmPassword" className="form-control" validations={[noSpace, required, minChar8]} />
          </FormGroup>
        </Col>
        <Col xs="12">
          <ButtonSubmit type="submit" className="btn btn-secondary changePassword">Atualizar senha</ButtonSubmit>
        </Col>
      </Form>);
  }
}

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: false,
      password: true,
      modal: false
    };

    this.toggleModal = this.toggleModal.bind(this);
  }


  logOut = () => {
    $.ajax({
      url: '/api/v1/logout',
      type: 'DELETE',
      success: function (res) {
        localStorage.clear();
        window.location.replace(window.location.protocol + "//" + window.location.host);
      }.bind(this),
      error: function (xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
    localStorage.clear();
    window.location.replace(window.location.protocol + "//" + window.location.host);
  }

  restartWowzaApplication = (event) => {
    event.preventDefault();
    $.ajax({
      url: '/api/v1/restart/application',
      type: 'GET',
      success: function (res) {
        this.props.notifySuccess(res.message);
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }

  toggleModal(e) {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
      <div className="Account d-flex flex-column flex-grow">
        <div className="Account__Main d-flex flex-column flex-grow px-5">
          <Breadcrumb tag="nav" className="relay-breadcrumb justify-content-end breadcrumb">
          </Breadcrumb>

          <div className="AccountDetails py-3">
            <Row>
              <Col xs="12" md="3" className="d-flex flex-column justify-content-start align-items-center">
                <div className="profile-card">
                  <span>
                    <img
                      className="media-library__tabel__img" className="rounded-circle"
                      style={{ width: '150px', height: '150px' }}
                      src={"https://picsum.photos/100/50"} alt="stream thumbnail" />
                  </span>
                  <br></br>
                  <small>{localStorage.getItem('email') ? localStorage.getItem('email') : null}</small>
                  <br></br>
                  <Button className="logOut" onClick={this.logOut}>Logout</Button>
                </div>

              </Col>
              <Col xs="12" md="9" lg="5">
                <Row className="h-100 profile-details">
                  <Col xs="12" md="3">

                    <div className="AccountDetails__v-tablinks nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      <a role="tab"
                        id="v-pills-profile-tab" className="nav-link active"
                        data-toggle="pill" href="#v-pills-password"
                        aria-controls="v-pills-password"
                        aria-selected="true">Senha</a>
                    </div>
                  </Col>

                  <Col xs="12" md="9" lg="8">

                    <div className="tab-content" id="v-pills-tabContent">
                      <div className="tab-pane fade active show" id="v-pills-password" role="tabpanel" aria-labelledby="v-pills-password-tab">
                        <Password notifySuccess={this.props.notifySuccess} notifyError={this.props.notifyError} />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs="12" md="9" lg="4">
                <Row className="h-100 profile-details">
                  <Col xs="12" md="8">

                    <div className="AccountDetails__v-tablinks nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      <a role="tab"
                        id="v-pills-profile-tab" className="nav-link active"
                        data-toggle="pill" href="#v-pills-password"
                        aria-controls="v-pills-password"
                        aria-selected="true">Manager</a>
                    </div>
                  </Col>
                  <Col>
                  <img src={RestartButton} style={{cursor: "pointer"}} width="40px" onClick={this.restartWowzaApplication} />
                  </Col>
                </Row>
                </Col>
            </Row>
          </div>
        </div>

        <Modal className="twoFactorModal" isOpen={this.state.modal} toggle={this.toggleModal} >
          <ModalBody>
            <TwoFactorForm toggleModal={this.toggleModal} notifySuccess={this.props.notifySuccess} notifyError={this.props.notifyError} />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default translate('translations')(Account);



// WEBPACK FOOTER //
// ./src/components/DashboardPage/Account/Account.js